export { getFeatureFlagClient, initialiseFeatureFlagClient } from './feature-flag-client';
export type { RawFlags } from '@atlassiansox/feature-flag-web-client';
